export default __webpack_public_path__ + "static/media/outside2.db16a805.webp";